import React from 'react'
import styles from './Passion.module.css'
import { Icon } from './Icon'

export const Passion = ({ name, iconClassName }) => (
  <span className={styles.passion}>
    <Icon className={iconClassName} inheritColor/>
    <span>{name}</span>
  </span>
)